var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 343,
    viewBox: "0 0 512 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.691895H512V342.018H0V0.691895Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 342.018V0.691895H512",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 67.5769V0.691895H411.67L0 275.133V342.018H100.33L512 67.5769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 0.691895V40.8169L60.193 342.018H0V301.893L451.807 0.691895H512Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.737 104.567L164.996 115.263L177.106 137.287L152.413 132.563L149.284 157.508L132.085 139.161L114.885 157.508L111.756 132.563L87.0631 137.286L99.1721 115.263L76.4331 104.567L99.1731 93.87L87.0631 71.848L111.756 76.57L114.886 51.626L132.085 69.973L149.285 51.626L152.413 76.57L177.106 71.848L164.998 93.872L187.737 104.567Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 341.333,
    fill: "white",
    transform: "translate(0 0.687988)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNa);
export default __webpack_public_path__ + "static/media/NA.1ae1068ca890f9655625cbdda928d9f7.svg";
export { ForwardRef as ReactComponent };